import FingerprintJS from '@fingerprintjs/fingerprintjs';

/**
 * @class DeviceService
 * @description Collect device identifier using FingerprintJS.
 */
class DeviceService {

    fpPromise;

    constructor() {
        this.fpPromise = FingerprintJS.load().catch(e => {
            console.warn('FingerprintJS is unavailable, continuing without deviceId:', e);
            return null;
        })
    }

    /**
     * @method getDeviceId
     * @description Gets device identifier using FingerprintJS.
     * @returns {Promise<string>}
     */
    async getDeviceId() {
        try {
            const fp = await this.fpPromise;
            if (!fp) {
                console.warn('FingerprintJS is unavailable, continuing without deviceId.');
                return '';
            }
            const fpResult = await fp.get();
            return fpResult.visitorId;
        } catch (e) {
            console.warn('FingerprintJS is unavailable, continuing without deviceId:', e);
            return '';
        }
    }
}

export {DeviceService};
